import { Chapter, Sequence } from '../state';
import { isInTestedOutChapter } from '../state/navigation/requiredPath';

type Item = Sequence | Chapter;

export interface ProgressSegment {
  id: string;
  length: number;
  index: number;
}

const getIndex = (chapter: Chapter, position: number) =>
  Math.max(0, Math.min(chapter.sequenceCount, position - chapter.position));

/**
 * One segment per chapter, filled up to the learner's place in the course.
 * Chapters the learner tested out of are done. While the learner reviews one,
 * progress is measured from where they left off, not from the slide on screen.
 */
export const progressSegments = (
  items: Item[],
  activeItemPosition: number,
  highestUnlockedPosition: number
): ProgressSegment[] => {
  const active = items.find(
    (item): item is Sequence =>
      item.kind === 'sequence' && item.position === activeItemPosition
  );
  const position =
    active && isInTestedOutChapter(items, active)
      ? highestUnlockedPosition
      : activeItemPosition;

  return items
    .filter((item): item is Chapter => item.kind === 'chapter')
    .map(chapter => ({
      id: chapter.id,
      length: chapter.sequenceCount,
      index: chapter.testedOut
        ? chapter.sequenceCount
        : getIndex(chapter, position)
    }));
};

export const coursePercentage = (segments: ProgressSegment[]) => {
  let lengthSum = 0;
  let indexSum = 0;
  segments.forEach(segment => {
    lengthSum += segment.length;
    indexSum += segment.index;
  });
  if (!lengthSum) return 0;
  return Math.round((indexSum * 100) / lengthSum);
};
